import { AfterViewInit, Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ModalPrivacyPolicyComponent } from '../modal-privacy-policy/modal-privacy-policy.component';

@Component({
  selector: 'app-modal-cookies',
  templateUrl: './modal-cookies.component.html',
  styleUrls: ['./modal-cookies.component.scss']
})
export class ModalCookiesComponent implements AfterViewInit {
  @ViewChild('body') body: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<ModalCookiesComponent>,
    private renderer2: Renderer2,
    private dialogPrivacy: MatDialog,
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
  ) { }

  ngAfterViewInit(): void {
    this.runCookiesScript();
  }

  public closeModal(): void {
    this.dialogRef.close();
  }

  public openPrivacy(): void {
    this.dialogRef.close();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      disableClose: true,
      autoFocus: false,
      panelClass: ['modal__full-screen']
    };
    this.dialogPrivacy.open(ModalPrivacyPolicyComponent, dialogConfig.data);
  }

  private runCookiesScript(): void {
    const script = this.renderer2.createElement('script');
    script.type = `text/javascript`;
    script.dataset.culture = this.i18NextService.language === 'es-ES' ? 'es' : 'pt';
    script.id = 'CookieDeclaration';
    script.src = 'https://consent.cookiebot.com/fa2eae20-4a21-404b-a849-1f743a97adf3/cd.js';
    script.async = true;
    this.renderer2.appendChild(this.body.nativeElement, script);
  }
}
